exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__recipe-card___1PkXy{position:relative;display:flex;flex-flow:column;width:450px;overflow:hidden;font-size:1rem;background-color:#fce4ec;color:#546e7a}a.styles__recipe-card-link___7HsiZ{display:flex;text-decoration:none}", ""]);

// exports
exports.locals = {
	"recipe-card": "styles__recipe-card___1PkXy",
	"recipe-card-link": "styles__recipe-card-link___7HsiZ"
};